import { useCallback } from "react";
import { useBuilderStore } from "../_stores/builder-store";
import type { ComponentImage } from "../_types";

/**
 * Returns a click handler for interactive image carousels on the canvas.
 * Selects the component and sets focusedField to open the image preview in the sidebar.
 *
 * @param componentId - The component that owns the carousel
 * @param prefix - Field prefix for focusedField (e.g., "carousel", "venue")
 */
export function useCanvasImageClick(
  componentId: string,
  prefix: string
): {
  handleImageClick: (image: ComponentImage) => void;
} {
  const setSelectedId = useBuilderStore((s) => s.setSelectedId);
  const setFocusedField = useBuilderStore((s) => s.setFocusedField);

  const handleImageClick = useCallback(
    (image: ComponentImage) => {
      setSelectedId(componentId);
      setFocusedField(`${prefix}-image:${image.id}`);
    },
    [componentId, prefix, setSelectedId, setFocusedField]
  );

  return { handleImageClick };
}
